"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _typeof2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/typeof.js"));
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'ModelScr',
  props: {
    // ----- elment-ui dialog 原始属性 -----
    isShow: {
      type: Boolean,
      default: false
    },
    dialogStatus: {
      // title
      type: String,
      default: 'create'
    },
    modal: {
      type: Boolean,
      default: true
    },
    modalAppendToBody: {
      type: Boolean,
      default: true
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '600px'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    customClass: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '15vh'
    },
    beforeClose: {
      type: Function,
      default: function _default() {}
    },
    center: {
      type: Boolean,
      default: true
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    // ----- elment-ui dialog 原始属性 -----

    // ----  关闭按钮时的数据比对 -----
    form: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    initForm: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    array: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    initArray: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // ----  关闭按钮时的数据比对 -----

    confirmBtnText: {
      // 确认按钮的文本
      type: String,
      default: 'confirm'
    },
    cancelBtnText: {
      // 取消按钮的文本
      type: String,
      default: 'cancel'
    }
  },
  data: function data() {
    return {};
  },
  computed: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, (0, _vuex.mapState)({
    needTagsView: function needTagsView(state) {
      return state.settings.tagsView;
    }
  })), {}, {
    isVisible: {
      get: function get() {
        return this.isShow;
      },
      set: function set(val) {
        this.$refs.detailSlot.scrollTo(0, 0);
        this.$emit('update:isShow', val);
      }
    },
    isJson: function isJson() {
      return function (val) {
        if (val && (0, _typeof2.default)(val) === 'object' && val.isJson) {
          return true;
        }
        return false;
      };
    },
    dialogTitle: function dialogTitle() {
      var hasKey = this.$te("common.".concat(this.dialogStatus));
      if (hasKey) {
        return this.$t("common.".concat(this.dialogStatus));
      }
      return this.dialogStatus;
    }
  }),
  watch: {
    isVisible: function isVisible(val) {
      if (val) {
        this.setParentStyle();
      } else {
        if (this.lockScroll) {
          // setTimeout(this.restoreParentStyle, 200)
          this.restoreParentStyle();
        }
      }
    }
  },
  methods: {
    clickCloseBtn: function clickCloseBtn(done) {
      var _this = this;
      // console.log('close------', this.form.values[1].state, this.initForm.values[1].state)
      var isSame = (0, _index.compareObject)(this.form, this.initForm);
      var isSame1 = (0, _index.compareArray)(this.array, this.initArray);
      // console.log('isSame--isSame1-------', isSame, isSame1)

      if (isSame && isSame1) {
        this.isVisible = false;
      } else {
        this.$confirm(this.$t('common.confirm11')).then(function (_) {
          _this.isVisible = false;
          // done()
        }).catch(function (_) {});
      }
    },
    closeFunc: function closeFunc() {},
    setParentStyle: function setParentStyle() {
      if (this.lockScroll) {
        (0, _index.addClass)(document.body, 'el-popup-parent--hidden');
      }
    },
    restoreParentStyle: function restoreParentStyle() {
      (0, _index.removeClass)(document.body, 'el-popup-parent--hidden');
    }
  }
};